
import { FoodItem } from '../types';

export interface OFFProduct {
  name_fr?: string;
  name_en?: string;
  name: string; // Fallback
  ingredients?: FoodItem[]; 
  image?: string;
  categoriesTags?: string[]; // Added for smart location detection
}

export const scanProduct = async (barcode: string): Promise<OFFProduct | null> => {
  try {
    const response = await fetch(
      `https://world.openfoodfacts.org/api/v2/product/${barcode}.json`
    );
    const data = await response.json();
    
    if (data.status === 1 && data.product) {
      const p = data.product;
      const name = p.product_name_fr || p.product_name_en || p.product_name || "Unknown Product";
      
      let ingredients: FoodItem[] = [];
      if (p.ingredients_tags && Array.isArray(p.ingredients_tags)) {
          ingredients = p.ingredients_tags.map((tag: string) => {
              const cleanTag = tag.split(':').pop() || tag;
              const name = cleanTag.replace(/-/g, ' ');
              return {
                  id: crypto.randomUUID(),
                  name: name,
                  quantity: 0,
                  unit: '',
                  timestamp: new Date()
              };
          });
      } else if (p.ingredients_text) {
          ingredients = p.ingredients_text.split(',').map((s: string) => ({
              id: crypto.randomUUID(),
              name: s.trim(),
              quantity: 0,
              unit: '',
              timestamp: new Date()
          }));
      }

      if (ingredients.length === 0) {
          ingredients = [{
              id: crypto.randomUUID(),
              name: name,
              quantity: 0,
              unit: '',
              timestamp: new Date()
          }];
      }

      return {
        name_fr: p.product_name_fr,
        name_en: p.product_name_en,
        name: name,
        ingredients: ingredients,
        image: p.image_url,
        categoriesTags: p.categories_tags || []
      };
    }
    return null;
  } catch (error) {
    console.error("OpenFoodFacts Fetch Error:", error);
    return null;
  }
};
